declare global {
  interface Window {
    dataLayer: unknown[]
    gtag: (...args: unknown[]) => void
  }
}

export function gtag() {
  // Google Analytics requires the command arguments object used by the official gtag snippet.
  // eslint-disable-next-line prefer-rest-params
  window.dataLayer.push(arguments)
}
